import * as actionTypes from '../actionTypes';
import initialState from './popularPlans.initialState';

const popularPlansReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.POPULAR_PLANS_SUCCESS:
      return {
        ...state,
        popularPlanAPiResponse: action.response,
      };
    case actionTypes.POPULAR_PLANS_FAILURE:
      return {
        ...state,
        popularPlanFailureAPiResponse: action.response,
      };
    case actionTypes.POPULAR_PLANS_MOCK:
      return {
        ...state,
        popularPlanMockResponse: action.response,
      };
    case actionTypes.SELECTED_PLANS:
      return {
        ...state,
        selectedPlans: action.response,
      };
    case actionTypes.DISPLAY_POPULAR_PERK_LIST:
      return {
        ...state,
        displayPopularPerkList: action.response,
      };
    default:
      return state;
  }
};

export default popularPlansReducer;
